import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

export default function HowItWorks() {
  const t = useT();
  const { STEPS } = useContent();

  return (
    <section data-testid="how-it-works-section" className="bg-ink py-24 md:py-32">
      <div className="container-site">
        <Chapter n={4} label={t['ch.howItWorks']} />
        <FadeUp>
          <h2 className="max-w-2xl font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            {t['hw.h2a']} <span className="italic text-gold">{t['hw.h2b']}</span>
          </h2>
        </FadeUp>
        <div className="mt-14 grid gap-10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={i * 0.12}>
              <div data-testid={`step-${s.n}`} className="relative border-t border-white/10 pt-8">
                <span className="font-serif text-6xl font-semibold text-gold/25">{s.n}</span>
                <h3 className="mt-4 font-serif text-2xl font-semibold text-white">{s.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-silver">{s.d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.2} className="mt-14 text-center">
          <Link data-testid="how-it-works-cta" to="/quote" className="gold-btn text-base !px-10 !py-4">
            {t['hw.cta']} <ArrowRight className="h-5 w-5" />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
